import { connect } from "react-redux";
import { push } from "react-router-redux";

import { userLoginSuccessAction, setAuthToken } from "../model/Benutzer";
import { settingsChangedAction } from "../model/Settings";
import WillkommenLogin from "./WillkommenLogin";

export default connect(state => ({
	authorized: state.user.isAuthorized
}), dispatch => ({
	loginSuccess: authorization => {
		/* setAuthToken() hat Nebenwirkungen. Deswegen nicht im Reducer
		 * ausführen.
		 */
		setAuthToken(authorization.token);
		/* Zusammen mit der Authorisierung werden die Einstellungen für
		 * den Benutzer geliefert.
		 */
		dispatch(settingsChangedAction("user", authorization.settings));
		dispatch(userLoginSuccessAction(authorization));
		/* Und gleich zur Startseite des Benutzers wechseln */
		dispatch(push(authorization.settings.start_page));
	}
}))(WillkommenLogin);
